import React from 'react';
import HelpDeskTicketList from './HelpDeskTicketList';

export default function HelpDeskQueue() {
  return (
    <HelpDeskTicketList
      title="Support queue (unassigned)"
      scope="queue"
      emptyHint="Open tickets with no owner. Use “Assign it to me” on a ticket to take ownership."
    />
  );
}
